<template>
  <div class="auth">
    <div class="auth-logo">
      <img src="@/assets/logo.png">
    </div>
    <div class="auth-container">
      <div class="auth-wrapper">
        <p class="auth-title">{{response.message}}</p>
        <button class="primary-button"
                v-if="response.verified"
                @click="$router.push({name: 'login'})">Back to login</button>
        <button class="primary-button"
                v-else
                @click="$router.push({name: 'register'})">Back to register</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import('../../components/Inputs/PrimaryInput.vue'),
    PrimaryButton: () => import('../../components/Buttons/PrimaryButton.vue'),
  },
  data: () => ({
    response: {
      message: '',
      verified: false
    }
  }),
  created() {
    this.$store.dispatch('registrationConfirm', this.$route.params.token).then(() => {
      this.response.message = 'Email Verified!'
      this.response.verified = true
    }).catch(() => {
      this.response.message = 'Email verification link has expired'
      this.response.verified = false
    })
  }
}
</script>

<style lang="scss" scoped>
.auth {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  .auth-logo {
    margin-top: 45px;
    margin-bottom: 75px;
  }
  .auth-container {
    margin-top: -152px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .auth-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 420px;
      border-radius: 4px;
      background-color: #ffffff;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
      padding: 60px;
      .auth-title {
        color: #000000;
        font-family: ""Helvetica Neue"";
        font-size: 24px;
        font-weight: bold;
        line-height: 24px;
        text-align: center;
        margin-bottom: 30px;
      }
      button {
        height: 40px;
      }
    }
  }
}
</style>

